import { BlotterType } from 'types/blotter-type'

export const blotterTypeLabels: Record<BlotterType, string> = {
  'open-orders': 'Open Orders',
  orders: 'Orders',
  trades: 'Trades',
  history: 'History',
}
